import { useTranslation } from "react-i18next";

import {
  IconArrowNarrowLeft,
  IconArrowNarrowRight,
  IconCalendar,
} from "@pentabd/icons";
import { Button, Table, Text } from "@pentabd/ui";

import { TableColumn } from "./TableColumn";

import { useApr } from "@hooks/HRM/apr/useAprList";

import { TablePagination } from "@helpers/tablePagination";

import { AprType } from "@type/HRM/aprs";

export const AprListTable = () => {
  const { t } = useTranslation();
  const { year, aprList, pagination, handleQuery } = useApr();

  const { total } = pagination || {};

  const modifiedData = aprList?.map((apr: AprType) => ({
    employeeID: apr.employee?.id,
    aprID: apr?.id,
    ...apr.employee,
    ...apr,
  }));

  return (
    <div className="mt-10">
      <Table
        columns={TableColumn(t) as any}
        rows={modifiedData}
        header={{
          badge: {
            label: `${total || 0}`,
            size: "sm",
            type: "primary",
          },
          title: t("APR_LIST.TABLE.HEADER"),
          buttons: [
            <div
              key="calendar"
              className="w-75 border border-info px-10 py-5 d-flex rounded justify-content-between align-items-center"
            >
              <div className="d-flex">
                <Button
                  className="p-0 border-none"
                  size="sm"
                  htmlType="button"
                  fill="outline"
                  type="light"
                  disabled={year <= 1900 ? true : false}
                >
                  <IconArrowNarrowLeft
                    size={20}
                    fill="subtitle2"
                    onClick={() => handleQuery("year", year - 1)}
                  />
                </Button>
              </div>
              <div className="d-flex align-items-center">
                <Text className="pe-3 mt-2">{year}</Text>
                <IconCalendar size="17" fill="subtitle2" className="p-0 m-0" />
              </div>
              <div className="d-flex">
                <Button
                  className="p-0 border-none"
                  size="sm"
                  htmlType="button"
                  fill="outline"
                  type="light"
                  disabled={year >= new Date().getUTCFullYear()}
                >
                  <IconArrowNarrowRight
                    size={20}
                    fill="subtitle2"
                    onClick={() => handleQuery("year", year + 1)}
                  />
                </Button>
              </div>
            </div>,
          ],
        }}
        pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
};
